import React, { useEffect, useState } from "react";
import { RefreshIcon } from "../icons";
import { CUSTOM_PERIOD, PERIODS } from "./activityUtils";

// Date <-> "YYYY-MM-DD" (the native date input's value), in local time.
const toInputValue = (d) => {
  if (!d) return "";
  const date = new Date(d);
  const pad = (n) => String(n).padStart(2, "0");
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
};
const fromInputValue = (v) => {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(v || "");
  return m ? new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3])) : null;
};

const CalendarIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <rect x="3" y="4" width="18" height="18" rx="2" /><line x1="16" y1="2" x2="16" y2="6" /><line x1="8" y1="2" x2="8" y2="6" /><line x1="3" y1="10" x2="21" y2="10" />
  </svg>
);

// Custom period: From / To inputs held as a draft until Apply, which sends them oldest-first.
const CustomRange = ({ dateRange, onApply }) => {
  const appliedFrom = toInputValue(dateRange[0]);
  const appliedTo = toInputValue(dateRange[1]);
  const [from, setFrom] = useState(appliedFrom);
  const [to, setTo] = useState(appliedTo);

  // Pick up ranges set from outside (e.g. an Insights link).
  useEffect(() => { setFrom(appliedFrom); setTo(appliedTo); }, [appliedFrom, appliedTo]);

  const today = toInputValue(new Date());
  const canApply = !!from && !!to && (from !== appliedFrom || to !== appliedTo);

  const apply = () => {
    const [older, newer] = [fromInputValue(from), fromInputValue(to)].sort((a, b) => a - b);
    onApply([older, newer]);
  };

  return (
    <>
      <label className="activity-date-field">
        <span>From</span>
        <input type="date" value={from} max={today} onChange={(e) => setFrom(e.target.value)} aria-label="From date" />
      </label>
      <label className="activity-date-field">
        <span>To</span>
        <input type="date" value={to} max={today} onChange={(e) => setTo(e.target.value)} aria-label="To date" />
      </label>
      <button type="button" className="activity-apply-btn" disabled={!canApply} onClick={apply}>
        <CalendarIcon />
        Apply
      </button>
    </>
  );
};

// Activity-wise controls shown on the right of the tabs bar: Period (+ From / To / Apply
// when Custom) and a manual refresh.
const ActivityToolbar = ({ period, dateRange, onPeriodChange, onDateRangeChange, onRefresh, refreshing, disabled }) => (
  <div className="activity-toolbar">
    <div className="activity-toolbar-right">
      <label className="activity-period">
        <span>Period</span>
        <select value={period} onChange={(e) => onPeriodChange(e.target.value)} aria-label="Activity period">
          {PERIODS.map((p) => <option key={p.value} value={p.value}>{p.label}</option>)}
        </select>
      </label>
      {period === CUSTOM_PERIOD && <CustomRange dateRange={dateRange} onApply={onDateRangeChange} />}
      <button type="button" className="tabs-refresh-btn" onClick={onRefresh} disabled={disabled || refreshing} title="Refresh" aria-label="Refresh">
        <span className={refreshing ? "activity-spin" : undefined}><RefreshIcon size={15} /></span>
      </button>
    </div>
  </div>
);

export default ActivityToolbar;
